var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.81625 24H16.5108C16.1947 23.4578 16 22.8355 16 22.1634V20.0002H0V21.2448C0 22.7667 1.2947 24 2.81625 24ZM3.00004 0V17.9999H18.0003V22.0001C18.0003 23.1001 18.9006 24 20.0005 24C21.1005 24 22.0004 23.1001 22.0004 22.0001V17.1758V0H3.00004ZM9.00013 16.0004H6.00022V13.0002H9.00013V16.0004ZM18.9999 5.00009H11.0004V3.00018H19.0003L18.9999 5.00009ZM9.00013 6.00009H6.00022V3.00018H9.00013V6.00009ZM18.9999 10.0003H11.0004V8.00035H19.0003L18.9999 10.0003ZM9.00013 11.0003H6.00022V8.00035H9.00013V11.0003ZM18.9999 15.0004H11.0004V13.0002H19.0003L18.9999 15.0004Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrders);
export default __webpack_public_path__ + "static/media/icon_orders.7af917d5e4ee5b2df80f594e5b5fed30.svg";
export { ForwardRef as ReactComponent };